// for local
// export const WEB_BASE_URL = 'http://52.193.241.114:8000/v2/'
// export const API_BASE_URL = 'http://18.182.102.216:8000/api/'

// for dev
// export const WEB_BASE_URL = 'http://52.193.241.114/v2/'
// export const API_BASE_URL = 'http://18.182.102.216/api/'

// for pro
export const WEB_BASE_URL = 'https://web.skyfox.sxi.co.jp/v2/'
export const API_BASE_URL = 'https://api.skyfox.sxi.co.jp/api/'



// WEBPACK FOOTER //
// ./src/defines/api.js